export const RouteName = {
  index: '/',
  login: '/login',
  home: '/home',

  home_ai: 'ai', // 数字人管理
  home_question_navigation: 'question-navigation', // 问题导航
  home_business_navigation: 'business-navigation', // 业务导航
  home_screen_account: 'screen-account', // 大屏账户
  home_seating_account: 'seating-account', // 坐席账户
}

export const RouteNavMapping = {
  '/home/ai': {
    defaultSelectedKeys: ['1'],
    defaultOpenKeys: []
  },
  '/home/carousel': {
    defaultSelectedKeys: ['2-1'],
    defaultOpenKeys: ['2']
  },
  '/home/question-navigation': {
    defaultSelectedKeys: ['2-2'],
    defaultOpenKeys: ['2']
  },
  '/home/business-navigation': {
    defaultSelectedKeys: ['2-3'],
    defaultOpenKeys: ['2']
  },
  '/home/screen-account': {
    defaultSelectedKeys: ['3-1'],
    defaultOpenKeys: ['3']
  },
  '/home/seating-account': {
    defaultSelectedKeys: ['3-1'],
    defaultOpenKeys: ['3']
  },
}